// CacheKey dc3fcde90ef34f70dad939fafc9dddaf
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-LHC": {
    data_view: {
      headers: {
        defaults: {
          comment: {
            related_encounter_id: "Enrollment ID"
          },
          encounter: {
            arrival_date: "Enrollment Date",
            created_at: "Enrollment Created Date",
            discharge_date: "Disenrollment Date",
            discharge_disposition: "Disenrollment Reason",
            discharged_by: "Disenrolled By",
            encounter_class_str: "Enrollment Class Str",
            encounter_id: "Enrollment ID",
            facility: "State",
            id: "Enrollment _id",
            patient_class: "Patient Status",
            risk_score_1_on_discharge: "Enrollment Type",
            surgical_encounter_status: "Surgical Enrollment Status"
          },
          interaction: {
            unit_name: "Agency Code"
          },
          issue: {
            related_encounter_id: "Enrollment ID"
          },
          unit: {
            name: "Agency",
            short_title: "Agency Name",
            facility: "State"
          }
        }
      }
    }
  }
}

